exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fq[data-v-7bb3ae66] {\n  background: #F7F7F7;\n}\n.fq .fq-detail img[data-v-7bb3ae66] {\n  width: 100%;\n}", ""]);

// exports
